import React, { Component } from "react";
import PostHeader from "./PostHeader";
import PostContent from "./PostContent";
import PostImage from "./PostImage";
import PostFooter from "./PostFooter";
import { getPostInfo } from "./postInfoUtils";
import PostPhraseModal from "./PostPhraseModal";
import "./PostContainer.scss";

import instagramIcon from "../../../../assets/instagram_image.png";

class PostContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phraseModal: false,
        };
    }

    addSelectedClass() {
        if (this.props.selectable && this.props.selectedPosts.indexOf(this.props.data._id) > -1) return true;
        return false;
    }

    showPhraseModal = () => {
        this.setState({ phraseModal: true });
    };

    render() {
        let info = getPostInfo(
            this.props.data,
            this.props.company ? this.props.company.company_lite_company_id : 0,
            this.props.appliedFilter,
            this.props.company?.virality_impact_threshold,
            this.props.conversationsDataParams,
            this.props.conversationsData,
        );

        if (info.postMediaType === "VIDEO" && info.postImg === null) {
            info.postImg = instagramIcon;
        }

        let sync_status;
        if (this.props.currentCollection && this.props.data._source.synced_collections) {
            this.props.data._source.synced_collections.map((s) => {
                if (s.collection_id === this.props.currentCollection.id) sync_status = s.status;
            });
        }

        let classNames = "";
        if ((this.props.selectAll && !this.props.deselected) || this.props.selected) classNames += "selected" + " ";
        if (this.props.className) classNames += this.props.className + " ";
        if (this.props.viewTypeInTab === "list") classNames += "post-container-list-view" + " ";
        if (this.props.viewTypeInTab === "3-col") classNames += "post-container-three-grid-view" + " ";

        // if (this.props.listView && !this.props.viralityContainer && !this.props.threeGridView  ) classNames += "post-container-list-view" + " ";
        // if(this.props.threeGridView  ) classNames+="post-container-three-grid-view" + " ";

        if (this.props.listView && this.props.viralityContainer) classNames += "post-container-virality-list-view" + " ";
        if (!this.props.listView && this.props.viralityContainer) classNames += "virality-data-card" + " ";
        if (this.props.className) classNames += this.props.className + " ";
        if (this.props.dashboardPageType == "SMP") classNames += "smp__dashboard";

        return (
            info && (
                <div id={"post-" + this.props.data._index + ":" + this.props.data._id} className={`post-container ${classNames}`}>
                    {this.props.selectable && (
                        <div
                            className="select-overlay"
                            onClick={() =>
                                this.props.selectAll || this.props.deselectedPostsCount > 0
                                    ? this.props.toggleToDeselect(this.props.data._index + ":" + this.props.data._id)
                                    : this.props.toggleSelected(this.props.data._index + ":" + this.props.data._id)
                            }>
                            {" "}
                        </div>
                    )}
                    <PostHeader
                        data={info}
                        index={this.props.index}
                        postIndex={this.props.postIndex}
                        postData={this.props.data}
                        location={this.props.location}
                        deletePostFromCollection={() => this.props.deletePostFromCollection(this.props.data)}
                        // assignedStatusModalShowSet={() => this.props.assignedStatusModalShowSet({ data: this.props.data, sync_status })}
                        sync_status={sync_status}
                        // setCoverPhoto={() => this.props.setCoverPhoto(info.postImg)}
                        listView={this.props.listView}
                        company={this.props.company}
                        updatePostAfterSentimentUpdate={this.props.updatePostAfterSentimentUpdate}
                        updatePostAfterMarkAsIrr={this.props.updatePostAfterMarkAsIrr}
                        updatePostAfterDeleteFromCollection={this.props.updatePostAfterDeleteFromCollection}
                        updatePostAfterTagToClient={this.props.updatePostAfterTagToClient}
                        dashboardPageType={this.props.dashboardPageType}
                        fetchCollectionData={this.props.fetchCollectionData}
                        isPublic={this.props.isPublic}
                        deletePublishedPost={this.props.deletePublishedPost}
                        smrPages={this.props.smrPages}
                        campaigns={this.props.campaigns}
                    />
                    <div className={`post-body`}>
                        {info.postImg && (
                            <PostImage data={info} listView={this.props.viewTypeInTab === "list"} dashboardPageType={this.props.dashboardPageType} />
                        )}
                        {!this.props.togglePost && this.props.tabInView === "conversations" && this.props.viewTypeInTab === "3-col" ? null : (
                            <PostContent
                                data={info}
                                customQuery={this.props.customQuery}
                                postData={this.props.data}
                                listView={this.props.viewTypeInTab === "list"}
                                dashboardPageType={this.props.dashboardPageType}
                            />
                        )}
                    </div>
                    <PostFooter
                        data={info}
                        postData={this.props.data}
                        postIndex={this.props.postIndex}
                        company={this.props.company}
                        updatePostAfterSentimentUpdate={this.props.updatePostAfterSentimentUpdate}
                        // showTempoTractionGraph={() => this.props.showTempoTractionGraph(info.tempoTractionData)}
                        LNOfflineModalShow={() => this.props.LNOfflineModalShow(this.props.data)}
                        viralityType={this.props.viralityType}
                        sync_status={sync_status}
                        listView={this.props.listView}
                        downloadParentPostCsv={this.props.downloadParentPostCsv}
                        dashboardPageType={this.props.dashboardPageType}
                        tabInView={this.props.tabInView}
                        isPublic={this.props.isPublic}
                        showPhraseModal={this.showPhraseModal}
                    />
                    <PostPhraseModal
                        open={this.state.phraseModal}
                        hideModal={() => this.setState({ phraseModal: false })}
                        // pharse={this.props.data.productAttributes[0].phrase}
                        data={info}
                    />
                </div>
            )
        );
    }
}

export default PostContainer;
